var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenuPre4(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16667 14.6667C4.63943 14.6667 5.83333 13.4728 5.83333 12C5.83333 10.5273 4.63943 9.33337 3.16667 9.33337C1.69391 9.33337 0.5 10.5273 0.5 12C0.5 13.4728 1.69391 14.6667 3.16667 14.6667Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16667 22.6667C4.63943 22.6667 5.83333 21.4728 5.83333 20C5.83333 18.5273 4.63943 17.3334 3.16667 17.3334C1.69391 17.3334 0.5 18.5273 0.5 20C0.5 21.4728 1.69391 22.6667 3.16667 22.6667Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83333 6.66671C11.3061 6.66671 12.5 5.4728 12.5 4.00004C12.5 2.52728 11.3061 1.33337 9.83333 1.33337C8.36057 1.33337 7.16667 2.52728 7.16667 4.00004C7.16667 5.4728 8.36057 6.66671 9.83333 6.66671Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83333 14.6667C11.3061 14.6667 12.5 13.4728 12.5 12C12.5 10.5273 11.3061 9.33337 9.83333 9.33337C8.36057 9.33337 7.16667 10.5273 7.16667 12C7.16667 13.4728 8.36057 14.6667 9.83333 14.6667Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83333 22.6667C11.3061 22.6667 12.5 21.4728 12.5 20C12.5 18.5273 11.3061 17.3334 9.83333 17.3334C8.36057 17.3334 7.16667 18.5273 7.16667 20C7.16667 21.4728 8.36057 22.6667 9.83333 22.6667Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83333 30.6667C11.3061 30.6667 12.5 29.4728 12.5 28C12.5 26.5273 11.3061 25.3334 9.83333 25.3334C8.36057 25.3334 7.16667 26.5273 7.16667 28C7.16667 29.4728 8.36057 30.6667 9.83333 30.6667Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.66671C17.9728 6.66671 19.1667 5.4728 19.1667 4.00004C19.1667 2.52728 17.9728 1.33337 16.5 1.33337C15.0272 1.33337 13.8333 2.52728 13.8333 4.00004C13.8333 5.4728 15.0272 6.66671 16.5 6.66671Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 14.6667C17.9728 14.6667 19.1667 13.4728 19.1667 12C19.1667 10.5273 17.9728 9.33337 16.5 9.33337C15.0272 9.33337 13.8333 10.5273 13.8333 12C13.8333 13.4728 15.0272 14.6667 16.5 14.6667Z",
    fill: "#222222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 22.6667C17.9728 22.6667 19.1667 21.4728 19.1667 20C19.1667 18.5273 17.9728 17.3334 16.5 17.3334C15.0272 17.3334 13.8333 18.5273 13.8333 20C13.8333 21.4728 15.0272 22.6667 16.5 22.6667Z",
    fill: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 30.6667C17.9728 30.6667 19.1667 29.4728 19.1667 28C19.1667 26.5273 17.9728 25.3334 16.5 25.3334C15.0272 25.3334 13.8333 26.5273 13.8333 28C13.8333 29.4728 15.0272 30.6667 16.5 30.6667Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1667 6.66671C24.6394 6.66671 25.8333 5.4728 25.8333 4.00004C25.8333 2.52728 24.6394 1.33337 23.1667 1.33337C21.6939 1.33337 20.5 2.52728 20.5 4.00004C20.5 5.4728 21.6939 6.66671 23.1667 6.66671Z",
    fill: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1667 30.6667C24.6394 30.6667 25.8333 29.4728 25.8333 28C25.8333 26.5273 24.6394 25.3334 23.1667 25.3334C21.6939 25.3334 20.5 26.5273 20.5 28C20.5 29.4728 21.6939 30.6667 23.1667 30.6667Z",
    fill: "#222222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1667 12C27.1667 10.5273 28.3606 9.33337 29.8333 9.33337C31.3061 9.33337 32.5 10.5273 32.5 12V20C32.5 21.4728 31.3061 22.6667 29.8333 22.6667C28.3606 22.6667 27.1667 21.4728 27.1667 20V12Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenuPre4);
export default __webpack_public_path__ + "static/media/venuPre4.f6c84adf02c1a7389accd61b24dc8eac.svg";
export { ForwardRef as ReactComponent };